var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 997,
    viewBox: "0 0 1440 997",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_75_166)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 400,
    width: 1040,
    height: 197,
    rx: 98.5,
    fill: "url(#paint0_linear_75_166)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_75_166",
    x: -200,
    y: 0,
    width: 1840,
    height: 997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_75_166"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_166",
    x1: -48.0862,
    y1: 264.562,
    x2: 1415.29,
    y2: 539.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#66FFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677959,
    stopColor: "#FBFF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24D8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterBackground);
export default __webpack_public_path__ + "static/media/center-background.98315edecb207e3933d92a7c282f8979.svg";
export { ForwardRef as ReactComponent };